import React from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, FormControlLabel, Grid } from '@mui/material';
import { useEvents } from 'hooks';
import { styled } from '@material-ui/styles';
import theme from 'theme';

const StyledGrid = styled(Grid)({
  [theme.breakpoints.up('xs')]: {
    justifyContent: 'flex-start',
  },
  [theme.breakpoints.down('xs')]: {
    justifyContent: 'space-evenly',
  },
});

const StyledFormControlLabel = styled(FormControlLabel)({
  [theme.breakpoints.down('xs')]: {
    '&.css-j204z7-MuiFormControlLabel-root': {
      marginRight: '0px',
    },
  },
});

const ShowArchiveFilter = () => {
  const { t } = useTranslation();
  const { showArchive, setShowArchive } = useEvents();

  return (
    <StyledGrid item container xs={6}>
      <Grid item>
        <StyledFormControlLabel
          key={'showarchive'}
          control={<Switch checked={showArchive} onChange={() => setShowArchive(!showArchive)} name={'showunread'} />}
          label={t('show_archive')}
        ></StyledFormControlLabel>
      </Grid>
    </StyledGrid>
  );
};

export default ShowArchiveFilter;
